import dateFns from 'date-fns'

import { set_Terrassor_INTERFACE, get_Terrassor_INTERFACE, Terrassor_RECALCULATE } from "../../../../interface.js"; 

/* @ngInject */
export class DescriptionMouvementController {
    /* @ngInject */
    constructor (ApiConst, ApiSimu, ApiExo, $scope, $filter) {
      this.ApiConst = ApiConst
      this.ApiSimu = ApiSimu
      this.ApiExo = ApiExo
      this.$scope = $scope
      this.$filter = $filter

      this.onResourceChange = this.onResourceChange.bind(this)

      this.$scope.$watch('DescriptionMouvementController.resource', this.onResourceChange)

      this.dateFormatFR = 'DD/MM/YYYY'

    }

    /*
    * Format à l'américaine --> datePicker !!!
    */
    datePourPicker(laDate) {
        var ddc =  new Date(laDate);
        var mois = ("0" + (ddc.getMonth() + 1)).slice(-2);
        var jour = ("0" + ddc.getDate()).slice(-2);
        return(mois+"/"+jour+"/"+ddc.getFullYear());
    }

    $onInit () {

    console.log('DescriptionMouvementController : init')

        // BC 2018/02 limitation au début du chantier - fait une fois pour toute pour tous les mouvements
        this.debutPossible =   this.datePourPicker(this.parentSimulator.getCurrentChantier().debut);
        this.liberationDebutPossible =  this.debutPossible; // la deuxième date - modifiée de façon dynamique plus tard


        // BC 09/17 - il faut aussi que le mouvement puisse accéder à sa description !!!  */

/*      console.log('DescriptionMouvementController --> require ^^simulator', this.parentSimulator)
      console.log('DescriptionMouvementController --> require ^^mouvement', this.parentMouvement)
      console.log('DescriptionMouvementController::$onInit for ', this.resource)
*/
      let hasResource = Boolean(this.resource)
      if(!hasResource)
        return
      
      this.currentMouvement = this.resource
      this.exoMouvement = this.currentMouvement.exoMouvement;
      this.simuMouvement = this.currentMouvement.simuMouvement;


      this.setDatesMouvement(simuMouvement) 

      this.formatDescriptionMouvement()
      this.formatPrevisionnelMouvement()  
    }

    /*
    */
    onResourceChange (newResource, oldResource) {

      let hasResource = Boolean(newResource)
      if(!hasResource) return
      if(newResource === oldResource) return

      console.log('DescriptionMouvementController::onResourceChange for ', newResource)
      this.currentMouvement = this.resource
      this.exoMouvement = this.currentMouvement.exoMouvement;
      this.simuMouvement = this.currentMouvement.simuMouvement;

      this.setDatesMouvement() 

      // infos "exo" du mouvement pour affichage dans la colonne "Paramètres"
      this.formatDescriptionMouvement()      
      this.formatPrevisionnelMouvement()  


    }


/*
* init champs input dates
* ! modif RA 17.03.08. Plus de date par défaut au 1er accès mouvement
*/
    setDatesMouvement() {      

      if(!this.currentMouvement)
        return
      var simuMouvement = this.currentMouvement.simuMouvement
      var debut = simuMouvement.debut
      var fin = simuMouvement.fin

      this.setDatesInputs(debut, fin)

    // BC 09/17 - il faut aussi que le mouvement puisse accéder à sa description !!! mais passe-t-on vraiment dans cette fonction ? si non test sur descriptionMouvement */
    this.parentMouvement.descriptionMouvement = this;

    }

    /*
    * interaction date : gérer la cohérence debut < fin, date debut > debut-chantier etc...
    */
    changeEndingDate() {
      if(!this.currentMouvement)
        return
    // check valdity  
    var fin = dateFns.parse(this.convert_FR_EN(this.endingDate))  
    if(!dateFns.isValid(fin))
        return 
    var simuMouvement = this.currentMouvement.simuMouvement
    // vérif modification réelle % valeur en BD
    if(simuMouvement.fin && (simuMouvement.fin.getTime() == fin.getTime()))
        return
    // pas de date antérieure au debut de chantier  +1
   /* var s_ddc = this.parentSimulator.currentChantier.debut
    var ddcplus1 =  new Date(s_ddc)
    ddcplus1 = dateFns.addDays(ddcplus1, 1)   
    if (fin.getTime() < ddcplus1.getTime())
      fin = ddcplus1        */

    fin = this.checkLimitDate(fin, 'end')

    //dates incohérentes debt/fin -> adapter 
    var debut = dateFns.parse(this.convert_FR_EN(this.beginningDate))
    if(!dateFns.isValid(debut) || debut.getTime() >= fin.getTime()) {
      fin = dateFns.addDays(debut, 1)   
    }

         
    this.setDatesInputs(debut, fin)
    return this.saveDatesMouvement(debut, fin)

    }

    /* BC ma propre fonction de date à cause de la bidouille qui rajoute 1 heure dans le code angular et dont je ne veux pas */
	dateChaine = function(laDate) {
        var lesMois = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
        var num=laDate.getDate();
        if (num < 10) {
            num = "0"+num;
        }
        else {
            num = ""+num;
        }
        var mois=lesMois[laDate.getMonth()];
        var an=laDate.getFullYear();
        return(""+num+'/'+mois+'/'+an);
    }


  /*
  *
  */changeBeginningDate(dateImposee) {
      if(!this.currentMouvement)
        return

      /* BC 09/2017  - on peut vouloir imposer une date */
    if (typeof(dateImposee) != 'undefined') {
        this.beginningDate = this.dateChaine(dateImposee)
    }
    /* fin BC */

    var debut = dateFns.parse(this.convert_FR_EN(this.beginningDate))  
    if(!dateFns.isValid(debut))
        return 
    var simuMouvement = this.currentMouvement.simuMouvement
    if(simuMouvement.debut && (simuMouvement.debut.getTime() == debut.getTime()))
        return 
    // pas de date antérieure au debut de chantier   ni > à 2 fois le delai prévu
   /* var ddc =  new Date(this.parentSimulator.getCurrentChantier().debut)
    if (debut.getTime() < ddc.getTime())
      debut = ddc
*/
    debut = this.checkLimitDate(debut, 'begin')
    //dates incohérentes -> adapter 
    var fin = dateFns.parse(this.convert_FR_EN(this.endingDate))
    if(!dateFns.isValid(fin) || debut.getTime() >= fin.getTime()) {
     fin = dateFns.addDays(debut, 1)     
    }

    this.setDatesInputs(debut, fin)
    return this.saveDatesMouvement(debut, fin)

    }

/*
*
*/
    checkLimitDate(d, type) {
      var s_ddc = this.parentSimulator.currentChantier.debut
      var ddc =  new Date(s_ddc)
      var ajust = (type == 'begin') ? -1 : 0
      var limit = dateFns.addDays(ddc, ajust+this.parentSimulator.currentChantier.delai * 2 /*CONSTANTES().depassementAutorise*/)
      if(d && d.getTime() < ddc)
        return ddc
      if(d && d.getTime() > limit.getTime())
        return limit
      else
        return d
    }


/*
* init des champs de saisie date et calendrier
*/
    setDatesInputs(debut, fin) {
      this.beginningDate = this.endingDate = ''
      if(debut) {
        this.beginningDate = dateFns.format(debut, this.dateFormatFR)
        this.beginCalendar = dateFns.parse(this.convert_FR_EN(this.beginningDate)).toISOString() // au format ISO pour l'init du calendar
      }

      if(fin) {
      this.endingDate = dateFns.format(fin, this.dateFormatFR)
      this.endCalendar =  dateFns.parse(this.convert_FR_EN(this.endingDate)).toISOString()

      }

              // BC 2018/02 - on met à jour la limite de la deuxième date en focntion de la premiere
        // je me demande s'il n'y a pas un bug au dessus, car le datePicker semble avoir besoin de dates au format US
      if (debut) {
        var lendemain = debut.getTime();
        var lendemainTime = lendemain + (60*60*24) * 1000; // 60 secondes * 60 minutes * 24 heures - On multiplie par 1000 car le time est exprimé en millisecondes
        var lendemainDate = new Date(lendemainTime);
        this.liberationDebutPossible = this.datePourPicker(lendemainDate);
        }

    }

    /*
    * Réenregistrer le mvt à chaque modification de date.
    * Ensuite, pusher dans l'interface et mettre à jour les infos previsionnelles
    */
    saveDatesMouvement(debut, fin) {
      if(!this.currentMouvement)
        return

      var simuMouvement = this.currentMouvement.simuMouvement
       simuMouvement.debut = debut
       simuMouvement.fin = fin
      // convert jj/mm/aaaa en mm/jj/aaaa avant de faire le parse

      console.log('DescriptionMouvementController::saveDatesMouvement debut/fin ', simuMouvement.debut, simuMouvement.fin)

      this.ApiSimu.saveMouvement(simuMouvement)
      .then(mvt => {      
        // trandformer les dates avant de pusher et vérifier cohérence (debut < fin)
        // et relancer les calculs pour mettre à jour le panneau 'prévisionnel'
        //this.pushMouvementToInterface(simuMouvement) fait dans saveMMouvement

        var retour = Terrassor_RECALCULATE();
        
        this.formatPrevisionnelMouvement()  
        // et le prévisionnel Chantier
        this.parentSimulator.setPropertiesForPanelChantier()
        this.parentSimulator.setPropertiesForPanelCubature()

        this.parentMouvement.doOnChangeMouvement()
      })
     // .catch(e => {console.log('error DB DescriptionMouvementController::saveDatesMouvement', e)})

    }



/*
*   Lecture BD des infos du mouvement et formattage pour affichage dans la colonne paramètres
*/
    setCurrentMouvement(codeMvt) {

      //this.ApiExo.getMouvementByCode(codeMvt, TerrassorConst.CODE_CHANTIER)
      this.ApiExo.getMouvementByCode(codeMvt, TerrassorConst.chantierCode) // BC 09/2017
      .then(rows => {
        var mvt = rows[0]
        this.currentMouvement = mvt
      })
      .then( _ => {console.log('todo, lecture/création du simu_mouvement correspondant à ', codeMvt)
      })
      .then(simu_mvt => console.log('todo, init de beginningDate et endingDate'))
    }

    getMaxLimitDate () {
      if(!this.currentMouvement)
         return null 
      var simuMouvement = this.currentMouvement.simuMouvement
      console.log('DescriptionMouvementController::getMaxLimitDate', simuMouvement, this.endingDate)

      return dateFns.parse(this.convert_FR_EN(simuMouvement.fin)).toUTCString()
    }

    getMinLimitDate () {
      if(!this.currentMouvement)
         return null 
      var simuMouvement = this.currentMouvement.simuMouvement
      return dateFns.parse(this.convert_FR_EN(simuMouvement.debut)).toUTCString()
    }

    convert_FR_EN (dateFR) {
      let [day, month, year] = dateFR.split('/')
      let dateEN = `${month}/${day}/${year}`
      return dateEN
    }

/*
* Description du mouvement sous une forme compatoble avec les propertiesLists
*/
    formatDescriptionMouvement() {
      var exo_mvt = this.exoMouvement
      
      var reglage = exo_mvt.reglage
      if (reglage) {
          this.parametresMouvement = [
                { label: "Distance",            value: this.$filter('number')(exo_mvt.distance) + ' m'}
                ];
          return;
      }

      var cubDepart = this.ApiExo.getCubatureImmediate(exo_mvt.exo_cubatures_depart_id)
      var cubArrivee = this.ApiExo.getCubatureImmediate(exo_mvt.exo_cubatures_arrivee_id)
      var sol = this.ApiExo.getTypeSolImmediate(exo_mvt.const_sol_id)
      var CubatureMouvementDepart = this.ApiExo.getCubatureMouvementImmediate(cubDepart.id, exo_mvt.id)
      var CubatureMouvementArrivee = this.ApiExo.getCubatureMouvementImmediate(cubArrivee.id, exo_mvt.id)

      var msgSensCubDepart = CubatureMouvementDepart.sens_inverse ? ' - opéré en sens inverse des PK' : ''
      var msgSensCubArrivee = CubatureMouvementArrivee.sens_inverse ? ' - opéré en sens inverse des PK' : ''


    this.parametresMouvement = [
      { label: "Cubature de départ",  value: cubDepart.code + ' (' + cubDepart.nom + ')' + msgSensCubDepart},
      { label: "Cubature d'arrivée",  value: cubArrivee.code + ' (' + cubArrivee.nom + ')' + msgSensCubArrivee},
      { label: "Distance",            value: this.$filter('number')(exo_mvt.distance) + ' m'},
      { label: "Type de sol",         value: sol.nom + ''},
      { label: "Humidité",         value: this.humidite + ''}, // BC attention bidouille cf. formatPrevisionnelMouvement
      { label: "Volume",              value: this.$filter('number')(exo_mvt.volume) + " m3" },
      { label: "Préparation / Traitement",      value: (exo_mvt.preparationtraitementdemande == "1") ? 'Oui' : 'Non' },
      { label: "Transformation",      value: (exo_mvt.transformationdemandee == "1") ? 'Oui' : 'Non' }      
    ];

    }

/*
*/
    formatPrevisionnelMouvement()    {
    var T_interface = get_Terrassor_INTERFACE()   
    var retour, result
    var code = this.exoMouvement.code

    this.previsionnelMouvement = [{ label: "Coût Total", value: ''},{ label: "Coût par m3", value: ''}, { label: "Rendement", value: ''}];

    retour = T_interface.action({"table":"simu_mouvements", "read":{"code":code, "previsionnel":"1"}});
    if(!retour.retour) {
      return 
    }

    result = retour.objet
    if ((typeof(result.humidite) != 'undefined') && (!this.exoMouvement.reglage)) {
        this.parametresMouvement[4].value = result.humidite
    }

    if(!retour.objet.retour) {
      return
    }

    this.previsionnelMouvement = [
            { label: "Coût Total", value: this.$filter('currency')(result.coutTotal.valeur)}, // + ' ' + result.coutTotal.unite }, //unité définie par le filtre 'currency'
            { label: "Coût par m3", value: this.$filter('currency')(result.coutParM3.valeur) + '/m3'},// + result.coutParM3.unite },
            { label: "Rendement", value: this.$filter('number')(Math.floor(0.5+result.rendement.valeur)) + ' ' + result.rendement.unite }  /*,
            { label: "Rendement Déblai", value: this.$filter('number')(Math.floor(0.5+result.rendementDeblai.valeur)) + ' ' + result.rendement.unite } ,
            { label: "Rendement Remblai", value: this.$filter('number')(Math.floor(0.5+result.rendementRemblai.valeur)) + ' ' + result.rendement.unite }    */
            ];

    }


}



// WEBPACK FOOTER //
// ./src/client/pages/simulator/components/description-mouvement/description-mouvement.controller.js